import { Alert, Badge, CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { ALERT_MESSAGES, CUSTOMER_TYPES } from '../../constants';
import { getOrderStatus } from '../../utils/order-status';
import { IDistributionView } from '../../models/active-orders';

const CARD_HEADER_CONTAINER_HEIGHT = 'sui-h-[65px]';

export const FulfillmentCardHeader = ({
  distribution,
  customerType,
  isMobile,
}: {
  distribution: IDistributionView;
  customerType: string;
  isMobile: boolean;
}) => {
  const { statusText, date, timeWindow } = getOrderStatus(distribution);

  const isStatusUnavailable = !distribution || !statusText || !(timeWindow ? date?.short : date?.long);

  if (isStatusUnavailable) {
    return (
      <div className={`sui-flex sui-flex-col sui-w-full ${CARD_HEADER_CONTAINER_HEIGHT} sui-mb-3`}>
        <Alert status="error">{ALERT_MESSAGES.ORDER_STATUS_UNAVAILABLE}</Alert>
      </div>
    );
  }

  const renderHeader = () => {
    const statusDate = timeWindow ? date?.short : date?.long;

    return (
      <>
        <Typography component="div" variant="body-base" data-testid="fulfillment-status-label">
          {statusText}
        </Typography>
        <Typography component="div" variant="body-base" weight="bold" data-testid="fulfillment-status-date">
          {statusDate}
          {timeWindow && `, ${timeWindow?.short}`}
        </Typography>
      </>
    );
  };

  const renderSubheader = () => {
    if (customerType !== CUSTOMER_TYPES.B2B) {
      return null;
    }

    const projectName = distribution?.projectName;

    if (!projectName) {
      return null;
    }

    return (
      <span className={`sui-block ${isMobile ? 'sui-w-40' : 'sui-w-80'}`}>
        <Typography
          component="span"
          truncate
          lineClamp="1"
          variant="body-sm"
          color="subtle"
          data-testid="project-name"
        >
          {projectName}
        </Typography>
      </span>
    );
  };

  const renderOrderMeta = () => {
    const { distributionType } = distribution;
    if (!distributionType) return null;

    return (
      <div className="sui-flex sui-items-center sui-gap-2 sui-mt-1">
        <Badge data-testid="fulfillment-distribution-type">
          {distributionType}
        </Badge>
      </div>
    );
  };

  return (
    <div className={`${CARD_HEADER_CONTAINER_HEIGHT} sui-mb-3`}>
      <CardTitle grow header={renderHeader()} subheader={renderSubheader()} />
      {renderOrderMeta()}
    </div>
  );
};
